import memoizeWithAllArguments from "@gef-ui/utils/memoizeWithAllArguments";
import { handleActions } from '@gef-ui/utils/fsaActions';
import __ from "ramda/es/__";
import compose from "ramda/es/compose";
import find from "ramda/es/find";
import identity from "ramda/es/identity";
import includes from "ramda/es/includes";
import keys from "ramda/es/keys";
import pluck from "ramda/es/pluck";
import prop from "ramda/es/prop";
import reject from "ramda/es/reject";
import union from "ramda/es/union";
import when from "ramda/es/when";
import isNotNil from "ramda-extension/es/isNotNil";
import mapKeys from "ramda-extension/es/mapKeys";
import { globalErrorAction } from '../../constants';
import { composeAction, flattenObject } from '../../utils';
const fieldNameP = prop('fieldName');
const clearGlobalErrors = {
    next (state, { payload }) {
        if (!payload) {
            return [];
        }
        const rejectPayload = (propName)=>(currentState)=>reject(compose(includes(__, pluck(propName)(payload)), prop(propName)), currentState);
        const propertyExistInPayload = (propName)=>isNotNil(find(prop(propName))(payload));
        const rejectPayloads = [
            identity
        ];
        const pushRejectPayload = (propName)=>rejectPayloads.push(rejectPayload(propName));
        const resolveForPropName = when(propertyExistInPayload, pushRejectPayload);
        resolveForPropName('fieldName');
        resolveForPropName('uniqueID');
        return compose(...rejectPayloads)(state);
    }
};
const updateGlobalErrors = {
    next (state, { payload }) {
        const remainingState = reject(compose(includes(__, keys(payload)), fieldNameP), state);
        return union(remainingState, flattenObject(payload));
    }
};
const globalErrorsActionsMap = {
    [globalErrorAction.CLEAR_GLOBAL_ERRORS]: clearGlobalErrors,
    [globalErrorAction.UPDATE_GLOBAL_ERRORS]: updateGlobalErrors
};
export default memoizeWithAllArguments((formName, defaultState = [])=>handleActions(mapKeys(composeAction(formName), globalErrorsActionsMap), defaultState));
